import React from "react";
import Main from "../../containers/Main";
import Projects from "../../containers/Projects";
import Services from "../../containers/Services";
import About from "../../containers/About";
import Formation from "../../containers/Formation";

class Page {
  constructor({
    name = "",
    root,
    image = null,
    staticProps = {},
    blurURL = null,
  }) {
    this.el = root;
    this.staticProps = staticProps;
    this.illu = { src: image, blur: blurURL };
    this.name = name;
  }
  root(props = {}) {
    props = { ...props, ...this.staticProps, name: this.name };
    return React.createElement(this.el, props);
  }
}

let pages= []
const mode = process.env.NEXT_PUBLIC_HOST_MODE || "portfolio";
if(mode == "freelance"){
  pages=[
      new Page({ root: Main, name: "Présentation",blurURL:
        null,  image: 'illu'}),
    new Page({
      name: "Mes services",
      root: Services,
      image: "illu",
    }),
    new Page({ root: Projects, name: "Mes réalisations" }),
    new Page({
      name: "A propos",
      root: About,
      image: "illu",
    }),]
}else if(mode=="portfolio"){
  pages=[
      new Page({ root: Main, name: "Présentation",blurURL:
        null,  image: 'illu'}),
      new Page({
        name: "Formation",
        root: Formation,
        image: "illu",
      }),
      new Page({ root: Projects, name: "Mes Projets" })
  ]
}

export default pages;
